import { HttpClient, HttpEvent } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable } from 'rxjs';
import { ApplicationsService } from '../../applications/services/application.service';
import { Staff } from '../../common/model/Staff';
import { ISharepointPackage } from '../../sales-and-delivery/models/ISharepointPackage';
import { SharepointPackageType } from '../../sales-and-delivery/models/SharepointPackageType';
import { SmartBankType } from '../../smart-bank/enum/SmartBankType';
import { SmartBankItemRejectModel } from '../../smart-bank/models/smart-bank/SmartBankItemRejectModel';
import { SmartBankBaseModel } from '../../smart-bank/models/smart-bank/SmartBankModel';
import { ITileOrder } from '../tile-container/tile-container.component';
import { BaseWithHttpService } from './baseWithHttp.service';

@Injectable({
  providedIn: 'root'
})
export class TileService extends BaseWithHttpService {
  apiUrl: string = '';

  packageType!: SharepointPackageType;
  constructor(http: HttpClient, @Inject(OKTA_AUTH) auth: OktaAuth, @Inject('CONFIG_SETTINGS') config: any, private baseService: ApplicationsService, private router: Router) {
    super(http, auth);
    const configSettings = config['general'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];
  }

  getFile(id: string, packageType: SharepointPackageType): Observable<HttpEvent<Blob>> {
    const token = this.getToken();
    const url = this.apiUrl + `SalesAndDeliveryHub/downloadsharepointfiles/${id}/${packageType}`;

    return this.getHttpOptionsFileTypeParams(token!, url);
  }
  getFileInChunk(id: string, packageType: SharepointPackageType, limit: number, offset: number): Observable<any> {
    const token = this.getToken();
    const url = this.apiUrl + `SalesAndDeliveryHub/downloadsharepointfiles/${id}/${packageType}/${limit}/${offset}`;

    return this.getHttpOptionsObjectTypeParams(token!, url);
  }

  async pinTile(tileid: string, tiletype: string) {

    const url = `${this.apiUrl}tiles/${tileid}/pin/${tiletype}`;
    return this.postAny(undefined, url).then(
      (response) => {
        return response;
      }
    );
  }
 
  unpinTile(tileid: string) {

    const url = `${this.apiUrl}tiles/${tileid}/unpin`;
    return this.postAny(undefined, url).then(
      (response) => {
        return response;
      }
    );
  }
  async pinMiroTile(tileid: string, tiletype: string) {
    const url = `${this.apiUrl}tiles/${tileid}/pinMiro/${tiletype}`;
    return this.postAny(undefined, url).then(
      (response) => {
        return response;
      }
    );
  }
  unpinMiroTile(tileid: string) {
    const url = `${this.apiUrl}tiles/${tileid}/unpinMiro`;
    return this.postAny(undefined, url).then(
      (response) => {
        return response;
      }
    );
  }

  getPinnedTiles(): Promise<IPinnedTile[]> {
    const url = `${this.apiUrl}tiles`;
    return this.getItems<IPinnedTile>(url);
  }

  getPinnedTilesForType(tiletype: string): Promise<IPinnedTile[]> {
    const url = `${this.apiUrl}tiles/` + tiletype;
    return this.getItems<IPinnedTile>(url);
  }

  //-------------------------
  getLatestProjectDeliverables(): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/latestprojectdeliverables`;
    return this.getItems<any>(url);
  }

  getDiamondIPPackages(packageType: SharepointPackageType): Promise<ISharepointPackage[]> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/diamondippackages/${packageType}`;
    return this.getItems<ISharepointPackage>(url);
  }
  getMarkettingData(packageType: SharepointPackageType): Promise<ISharepointPackage[]> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/diamondippackages/${packageType}`;
    return this.getItems<ISharepointPackage>(url);
  }
  getSalesData(packageType: SharepointPackageType): Promise<ISharepointPackage[]> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/diamondippackages/${packageType}`;
    return this.getItems<ISharepointPackage>(url);
  }
  getProposalsData(packageType: SharepointPackageType): Promise<ISharepointPackage[]> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/diamondippackages/${packageType}`;
    return this.getItems<ISharepointPackage>(url);
  }
  getDeliveryData(packageType: SharepointPackageType): Promise<ISharepointPackage[]> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/diamondippackages/${packageType}`;
    return this.getItems<ISharepointPackage>(url);
  }
  getGeneralPurposeData(packageType: SharepointPackageType): Promise<ISharepointPackage[]> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/diamondippackages/${packageType}`;
    return this.getItems<ISharepointPackage>(url);
  }
  getDeliveryStarData(packageType: SharepointPackageType): Promise<ISharepointPackage[]> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/diamondippackages/${packageType}`;
    return this.getItems<ISharepointPackage>(url);
  }
  getTreeViewPackages(packageType: SharepointPackageType): Promise<ISharepointPackage[]> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/treeviewmodel/${packageType}`;
    return this.getItems<ISharepointPackage>(url);
  }

  downloadSharePointFiles(id: String, packageType: SharepointPackageType): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/downloadsharepointfiles/${id}/${packageType}`;
    return this.getItems<any>(url);

  }
  getTeamViewFolder(encodedPackageName: String): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/getteamfolder/${encodedPackageName}`;
    return this.getItems<any>(url);

  }
  downloadProposalFiles(type: string): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/downloadproposalfile/${type}`;
    return this.getItems<any>(url);

  }
  //-------------------------
  //-----smart bank-----
  getReferenceLibraryData(packageType: SmartBankType): Promise<any> {
    const url = `${this.apiUrl}SmartBank/referenceLibrary/${packageType}`;
    return this.getItems<any>(url);

  }
  getEditReferenceLibraryData(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/editreferenceLibrary/${id}`;
    return this.getItems<any>(url);

  }
  getEditDidYouKnowData(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/editDidYouKnow/${id}`;
    return this.getItems<any>(url);

  }

  getTipOfTheWeekData(packageType: SmartBankType): Promise<any> {
    const url = `${this.apiUrl}SmartBank/gettipoftheweek/${packageType}`;
    return this.getItems<any>(url);

  }
  async getEditTipOfTheWeekData(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/geeditttipoftheweek/${id}`;
    return this.getItems<any>(url);

  }
  getDidYouKnowData(packageType: SmartBankType): Promise<any> {
    const url = `${this.apiUrl}SmartBank/getdidyouknow/${packageType}`;
    return this.getItems<any>(url);

  }
  getProposalSlideInit(): Promise<any> {
    const url = `${this.apiUrl}SmartBank/getinitproposalslide`;
    return this.getItems<any>(url);

  }

  getProposalExampleInit(): Promise<any> {
    const url = `${this.apiUrl}SmartBank/getinitproposalexample`;
    return this.getItems<any>(url);

  }
  getEditCaseStudy(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/geteditcasestudy/${id}`;
    return this.getItems<any>(url);

  }
  getReadOnlyCaseStudy(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/getreadonlycasestudy/${id}`;
    return this.getItems<any>(url);

  }
  getTreeViewModel(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/gettreeviewmodel/${id}`;
    return this.getItems<any>(url);

  }
  async getCaseStudyData(packageType: SmartBankType): Promise<any> {
    const url = `${this.apiUrl}SmartBank/getcasestudy/${packageType}`;
    return this.getItems<any>(url);

  }
  async getCuration(): Promise<any[]> {
    const url = `${this.apiUrl}SmartBank/getcurationitemstoApprove`;
    return this.getItems<any>(url)

  }
  async getCurationApproved(): Promise<any> {
    const url = `${this.apiUrl}SmartBank/GetApprovedCurationItems`;
    return this.getItems<any>(url);

  }
  async setApprovalByType(smartBankType: SmartBankType, id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/approveitem/${smartBankType}/${id}`;
    //if (!isNullOrEmptyString(id)) {
    //  //alert('Item Approved');
    //}
    return this.getItems<any>(url);
  }
  async getApprovedItemsByType(SmartBankType: SmartBankType): Promise<any> {
    const url = `${this.apiUrl}SmartBank/getapproveditemsbytype/${SmartBankType}`;
    return this.getItems<any>(url);

  }

  async loadProjectsByClientId(clientId: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/loadprojectsbyclient/${clientId}`;
    return this.getItems<any>(url);

  }
  //async getSmartBankSearch(searchText: string, queryReferenceItem: boolean, queryTipOfTheWeek: boolean, queryDidYouKnow: boolean, queryCaseStudy: boolean): Promise<any> {
  //  const url = `${this.apiUrl}smartbank/Query/${searchText}/${queryReferenceItem}/${queryTipOfTheWeek}/${queryDidYouKnow}/${queryCaseStudy}`;
  //  return this.getItems<any>(url);
  //}
  async getSmartBankSearch(model: SearchParameter): Promise<any> {
    const url = `${this.apiUrl}smartbank/query`;
    // return this.getItems<any>(url);
    return this.postAny(model, url);
  }


  async saveReferenceVariable(model: SmartBankBaseModel): Promise<any> {
    const url = `${this.apiUrl}SmartBank/saveReferenceLibrary`;

    //return this.getItems<any>(url);
    return this.postAnyFormData(model, url);

    //return this.postAny(model, url);
  }
  async saveTipOfTheWeek(data: any) {
    const url = `${this.apiUrl}SmartBank/savetipoftheweek`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }
  async saveDidYouKnow(data: any) {
    const url = `${this.apiUrl}SmartBank/savedidyouknow`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }
  async saveCaseStudy(data: any) {
    const url = `${this.apiUrl}SmartBank/SaveCaseStudy`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }
  async getProjectNumbersByProjectIds(projectIds: any) {
    const url = `${this.apiUrl}SmartBank/getprojectnumbersbyprojectids`;
    return this.postAnyFormData(projectIds, url);
  }
  async findClosedProjects(projectIds: any): Promise<any> {
    const url = `${this.apiUrl}SmartBank/findclosedprojects`;
    return this.postAnyFormData(projectIds, url);
  }
  viewDidYouKnowFile(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/viewdidyouknow/${id}}`;
    return this.getItems<any>(url);

  }

  getProposalsTermMapping(): Promise<ProposalsTermMapping[]> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/proposalsTermMapping`;
    return this.getItems<ProposalsTermMapping>(url);
  }

  async OrderTile(tiledetails: ITileOrder[]) {
    const url = `${this.apiUrl}tiles/rearrangeorder`;
    return this.postAny(tiledetails, url).then(
      (response) => {
        return response;
      }
    );
  }


  async OrderTileApplication(tiledetails: ITileOrder[]) {
    const url = `${this.baseService.apiUrl}application/rearrangeorderapp`;
    return this.postAny(tiledetails, url).then(
      (response) => {
        return response;
      }
    );
  }

  async OrderTileExpert(tiledetails: ITileOrder[]) {
    const url = `${this.baseService.apiUrl}experts/rearrangeorderexpert`;
    return this.postAny(tiledetails, url).then(
      (response) => {
        return response;
      }
    );
  }

  async OrderTileTaskList(tiledetails: ITileOrder[]) {
    const url = `${this.baseService.apiUrl}tasklist/rearrangeordertasklist`;
    return this.postAny(tiledetails, url).then(
      (response) => {
        return response;
      }
    );
  }
  getAssesmentCatalogue(): Promise<IPinnedTile[]> {
    const url = `${this.apiUrl}Assessment/assesmentCatalogue`;
    return this.getItems<IPinnedTile>(url);
  }
  getAssesmentList(archieve: boolean): Promise<IPinnedTile[]> {
    const url = `${this.apiUrl}Assessment/getAssesmentList/${archieve}`;
    return this.getItems<IPinnedTile>(url);
  }
  getAssesmentBySurveyId(id: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getAssesmentBySurveyId/${id}`;
    return this.getItems<any>(url);
  }
  getAssesmentCatalogueTreeview(): Promise<any> {
    const url = `${this.apiUrl}Assessment/getTreeView`;
    return this.getItems<any>(url);
  }
  //Assessment summary
  async getAssessmentSummary(id: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getassessmentsummary/${id}`;
    return this.getItems<any>(url);
  }
  //Demographic Data
  async getDemographicDataManagement(id: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getdemographicdatamanagement/${id}`;
    return this.getItems<any>(url);
  }
  //Respondent Management
  async getRespondentManagement(id: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getrespondentmanagement/${id}`;
    return this.getItems<any>(url);
  }
  //Get Email/Message Management
  async getEmailMessageManagement(id: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getemailmessagemanagement/${id}`;
    return this.getItems<any>(url);
  }
  //Get survey status
  async getSurveyStatus(id: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getsurveystatus/${id}`;
    return this.getItems<any>(url);
  }
  //Get Team Member
  async getTeamMembers(id: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getTeamMembers/${id}`;
    return this.getItems<any>(url);
  }
  //Get Assessment History
  async getAssessmentHistory(id: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getAssessmentHistory/${id}`;
    return this.getItems<any>(url);
  }
  async getAssessmentTemplates(): Promise<any> {
    const url = `${this.apiUrl}Assessment/getAssessmentTemplates`;
    return this.getItems<any>(url);
  }
  //workspace
  async LoadOneSysProjectsForUser(): Promise<any> {
    const url = `${this.apiUrl}Assessment/loadonesysprojectsforuser`;
    return this.getItems<any>(url);

  }
  async LoadTeams(): Promise<any> {
    const url = `${this.apiUrl}Workspace/loadteams`;
    return this.getItems<any>(url);

  }
  async GetStaff(): Promise<any> {
    const url = `${this.apiUrl}Assessment/getstaffList`;
    return this.getItems<any>(url);

  }
  async saveNewWorkSpace(data: any) {
    const url = `${this.apiUrl}Workspace/saveworkspace`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }
  async GetTeammemberDetails(workspaceId: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/teammemberlist/${workspaceId}`;
    return this.getItems<any>(url);

  }
  async addRejectDetails(SmartBankItemRejectModel: SmartBankItemRejectModel): Promise<any> {
    const url = `${this.apiUrl}SmartBank/addrejectdetails/${SmartBankItemRejectModel.id}/${SmartBankItemRejectModel.smartBankType}`;
    return this.getItems<any>(url);
  }
  async saveRejectItem(model: SmartBankItemRejectModel) {
    const url = `${this.apiUrl}SmartBank/rejectedItem`;
    return this.postAny(model, url).then(
      (response) => {
        return response;
      }
    );
  }
  //Assessment
  async saveNewAssessment(data: any) {
    const url = `${this.apiUrl}Assessment/saveassessment`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }

  async savePinnedAssessment(data: any) {
    const url = `${this.apiUrl}Assessment/savepinnedassessment`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }

  //
  async getSharepointUrl(urlDetail: string): Promise<any> {
    var formdata = new FormData();
    formdata.append('model', urlDetail)
    const url = `${this.apiUrl}SmartBank/geturlfromsharepoint`;
    return this.postAnyFormData(formdata, url)
      .then(
        (response) => {
          return response;
        }
      );
  }
  async getWorkspaceByuserEmail() {
    const url = `${this.apiUrl}Workspace/getworkspacebyuseremail`;
    return this.getItems<any>(url);
  }
  //getassessmentdata
  async GetTeamMemberByWorkspaceId(id: string) {
    const url = `${this.apiUrl}Assessment/teammemberlist/${id}`;
    return this.getItems<any>(url);
  }
  async GetAssessmentDbData() {
    const url = `${this.apiUrl}Assessment/getassessmentdata`;
    return this.getItems<any>(url);
  }
  async saveRespondents(respondents: any): Promise<any> {
    const url = `${this.apiUrl}Assessment/saverespondents`;
    return this.postAnyFormData(respondents, url)
      .then(
        (response) => {
          return response;
        }
      );
  }
  async deleteRespondents(respondents: any): Promise<any> {
    const url = `${this.apiUrl}Assessment/deleterespondents`;
    return this.postAnyFormData(respondents, url)
      .then(
        (response) => {
          return response;
        }
      );
  }
  async saveDemographicData(data: any): Promise<any> {
    const url = `${this.apiUrl}Assessment/savedemographicdata`;
    return this.postAnyFormData(data, url)
      .then(
        (response) => {
          return response;
        }
      );
  }
  async saveEmailNotificationData(data: any): Promise<any> {
    const url = `${this.apiUrl}Assessment/saveemaildetails`;
    return this.postAnyFormData(data, url)
      .then(
        (response) => {
          return response;
        }
      );
  }
  async saveAssessmentSummary(data: any): Promise<any> {
    const url = `${this.apiUrl}Assessment/saveassessmentsummary`;
    return this.postAnyFormData(data, url)
      .then(
        (response) => {
          return response;
        }
      );
  }
  async saveAdhocReminder(data: any) {
    const url = `${this.apiUrl}Assessment/saveadhocreminder`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }
  async sendSurvey(data: any) {
    const url = `${this.apiUrl}Assessment/sendsurvey`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }
  async exportDataToExcel(surveyId: any) {
    const url = `${this.apiUrl}Assessment/exportdatatoexcel/${surveyId}`;
    return this.getItems<any>(url);
  }

  async exportCreateToExcel(surveyId: any) {
    const url = `${this.apiUrl}Assessment/ExportCreateDataToExcel/${surveyId}`;
    return this.getItems<any>(url);
  }

  async uploadDataToExcel(data: any) {
    const url = `${this.apiUrl}Assessment/uploaddatatoexcel`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }

  async saveTeamList(data: any) {
    const url = `${this.apiUrl}Assessment/saveTeamList`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }
  async getSavedTeamMemberList(model: any) {
    const url = `${this.apiUrl}Assessment/getsavedteammemberlist`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async teamMemberListDetails(surveyId: any) {
    const url = `${this.apiUrl}Assessment/teammemberListdetails/${surveyId}`;
    return this.getItems<any>(url);
  }
  async getCurrentUser() {
    const url = `${this.apiUrl}Assessment/getcurrentuser`;
    return this.getItems<any>(url);
  }
  async getTeamChannel(teamId: string) {
    const url = `${this.apiUrl}Workspace/GetChannelsForTeam/${teamId}`;
    return this.getItems<any>(url);
  }
  async saveWorkSpaceTaskList(workspaceList: WorkspaceTaskListModel[]) {
    const url = `${this.apiUrl}Workspace/saveworkspacetasklist`;
    return this.postAny(workspaceList, url).then(
      (response) => {
        return response;
      }
    );
  }
  async getWorkspaceTaskList() {
    const url = `${this.apiUrl}Workspace/getworkspacetasklist`;
    return this.getItems<any>(url);
  }
  async deleteWorkSpaceTask(workspaceTask: WorkspaceTaskListModel) {
    const url = `${this.apiUrl}Workspace/deleteworkspacetasklist`;
    return this.postAny(workspaceTask, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getWorkSpaceHistory(id: string): Promise<any> {
    const url = `${this.apiUrl}Workspace/getworkspacehistory/${id}`;
    return this.getItems<any>(url);
  }
  async getWorkSpaceFavouriteDocument(id: string): Promise<any> {
    const url = `${this.apiUrl}Workspace/getfavouritedocument/${id}`;
    return this.getItems<any>(url);
  }
  async getWorkSpaceNotification(id: string): Promise<any> {
    const url = `${this.apiUrl}Workspace/getworkspacenotification/${id}`;
    return this.getItems<any>(url);
  }

  //WorkspaceAssessments()
  async getWorkspaceAssessmentList(workspaceId: string) {
    const url = `${this.apiUrl}Workspace/getworkspaceassessments/${workspaceId}`;
    return this.getItems<any>(url);
  }
  async saveAssessmentWorkspace(workspaceAssessment: any) {
    const url = `${this.apiUrl}Workspace/saveassessmentworkspace`;
    return this.postAny(workspaceAssessment, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  //loadWorkspaceAssessments
  async loadWorkspaceAssessments(workspaceId: string) {
    const url = `${this.apiUrl}Workspace/loadWorkspaceAssessments/${workspaceId}`;
    return this.getItems<any>(url);
  }
  async deleteWorkSpaceAssessment(workspaceTask: WorkspaceTaskListModel) {
    const url = `${this.apiUrl}Workspace/deleteassessmentworkspace`;
    return this.postAny(workspaceTask, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async updateWorkspaceTeamMember(workspaceTeamMember: WorkspaceTeamMember) {
    const url = `${this.apiUrl}Workspace/updateteammember`;
    return this.postAny(workspaceTeamMember, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async loadTeamMemberByOnesysId(onesysId: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/loadTeammemberByOneSysId/${onesysId}`;
    return this.getItems<any>(url);

  }
  getNotificationsByEmail(): Promise<any> {
    const url = `${this.apiUrl}core/notifications`;
    //users/{email}/notifications
    return this.getItems<any>(url);
  }
  async getWorkspacessummary(workspaceId: string) {
    const url = `${this.apiUrl}Workspace/getworkspacesummary/${workspaceId}`;
    return this.getItems<any>(url);
  }
  async handleWorkspaceArchive(archiveModel: any) {
    const url = `${this.apiUrl}Workspace/saveworkspaceasarchieved`;
    return this.postAny(archiveModel, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async tasklistArchive(archiveModel: any) {
    const url = `${this.apiUrl}tasklist/savetasklistarchive`;
    return this.postAny(archiveModel, url).then(
      (response: any) => {
        return response;
      }
    );
  }

  async getTeamMemberByChannelId(archiveModel: any) {
    const url = `${this.apiUrl}Workspace/GetMembersfromTeamId`;
    return this.postAny(archiveModel, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async updateTeamLinks(model: any) {
    const url = `${this.apiUrl}Workspace/updateWorkspaceTeamChannel`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getMsTeamDocument(workspaceId: string) {
    const url = `${this.apiUrl}Workspace/GetMsTeamDocument/${workspaceId}`;
    return this.getItems<any>(url);
  }
  async saveFavouriteDocument(model: any) {
    const url = `${this.apiUrl}Workspace/savefavouritedocuments`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getWorkspacesWithAssignedUsers(isArchived: boolean) {
    const url = `${this.apiUrl}Workspace/workspaceswithassignedusers/${isArchived}`;
    return this.getItems<any>(url);
  }
  async getTaskListWithArchived(isArchived: boolean) {
    const url = `${this.apiUrl}tasklist/tasklistwitharchived/${isArchived}`;
    return this.getItems<any>(url);
  }
  async getSelectedFavouriteDocument(workspaceId: string) {
    const url = `${this.apiUrl}Workspace/getselectedfavouritedocument/${workspaceId}`;
    return this.getItems<any>(url);
  }
  async deleteFavouriteDocument(model: any) {
    const url = `${this.apiUrl}Workspace/deletefavouritedocuments`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getAllworkspaces() {
    const url = `${this.apiUrl}Workspace/getallworkspaces`;
    return this.getItems<any>(url);
  }
  async getAssessmentDetailsById(surveyId: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getAssesmentById/${surveyId}`;
    return this.getItems<any>(url);
  }
  getAssesmentListForUser(): Promise<IPinnedTile[]> {
    const url = `${this.apiUrl}Assessment/getAssesmentListForUser`;
    return this.getItems<IPinnedTile>(url);
  }
  async getProjectOwner(onesysId: string): Promise<any> {
    const url = `${this.apiUrl}Workspace/getprojectowner/${onesysId}`;
    return this.getItems<any>(url);
  }
  async getWorkspaceById(id: string): Promise<any> {
    const url = `${this.apiUrl}Workspace/Workspaces/${id}`;
    return this.getItems<any>(url);
  }
  async getWorkspaceOwner(email: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/getworkspaceowner/${email}`;
    return this.getItems<any>(url);
  }
  async savePinnedDiamondIp(data: any) {
    const url = `${this.apiUrl}SalesAndDeliveryHub/savepinneddiamondip`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }
  async getAllPinnedDiamondIp(): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/getallpinneddiamondip`;
    return this.getItems<any>(url);
  }
  async getAssociatedTasks(): Promise<any> {
    const url = `${this.apiUrl}Workspace/getassociatedtasks`;
    return this.getItems<any>(url);
  }
  async clearAllNotification() {
    const url = `${this.apiUrl}core/clearnotifications`;
    return this.deleteAny(url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getCarbonOffset(): Promise<any> {
    const url = `${this.apiUrl}Common/getcarbonoffset`;
    return this.getItems<any>(url);
  }
  async saveCarbonOffset(model: any) {
    const url = `${this.apiUrl}Common/savecarbonoffset`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getWordOfTheWeek(): Promise<any> {
    const url = `${this.apiUrl}Common/getwordoftheweek`;
    return this.getItems<any>(url);
  }
  async saveWordOfTheWeek(model: any) {
    const url = `${this.apiUrl}Common/savewordoftheweek`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async updateWordOfTheWeek(model: any) {
    const url = `${this.apiUrl}Common/updatewordoftheweek`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async deleteWordOfTheWeek(id: any) {
    const url = `${this.apiUrl}Common/deletewordoftheweek/${id}`;
    return this.deleteAny(url).then(
      (response: any) => {
        return response;
      }
    );
  }

  async validateStartDate(model: any) {
    const url = `${this.apiUrl}Common/validatestartdate`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getcurrentWordOfTheWeek(): Promise<any> {
    const url = `${this.apiUrl}Common/getcurrentwordoftheweek`;
    return this.getItems<any>(url);
  }
  getAllNotificationsByEmail(): Promise<any> {
    const url = `${this.apiUrl}core/usersallnotifications`;
    return this.getItems<any>(url);
  }
  async getUserLeaderBoard(): Promise<any> {
    const url = `${this.apiUrl}Common/getuserleaderboard`;
    return this.getItems<any>(url);
  }
  async getTipOfTheWeekVideoLink(): Promise<any> {
    const url = `${this.apiUrl}SmartBank/gettipoftheweekvideourl`;
    return this.getItems<any>(url);
  }
  async getUserUtilizationMetrics(): Promise<any> {
    const url = `${this.apiUrl}Common/getutilizationmetrics`;
    return this.getItems<any>(url);
  }
  async getUserSalesCreditMetrics(): Promise<any> {
    const url = `${this.apiUrl}Common/getsalescreditmetrics`;
    return this.getItems<any>(url);
  }
  async getUserCcxScore(): Promise<any> {
    const url = `${this.apiUrl}Common/ccxscore`;
    return this.getItems<any>(url);
  }
  async getMetricsData(): Promise<any> {
    const url = `${this.apiUrl}Common/getMetricsData`;
    return this.getItems<any>(url);
  }

  async getStaffUtilization(): Promise<any> {
    const url = `${this.apiUrl}Common/getStaffUtilzation`;
    return this.getItems<any>(url);
  }


  async updateWorkspaceName(model: any) {
    const url = `${this.apiUrl}Workspace/updateworkspacename`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async updateTaskListName(model: any) {
    const url = `${this.apiUrl}tasklist/updatetasklistname`;
    return this.postAny(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getMiroDetails(): Promise<any> {
    const url = `${this.apiUrl}Miro/getMiroDetails`;
    return this.getItems<any>(url);
  }
  async isMiroExist(): Promise<any> {
    const url = `${this.apiUrl}Miro/ismirotokenexist`;
    return this.getItems<any>(url);
  }
  async saveMiroToken(model: any) {
    const url = `${this.apiUrl}Miro/token`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async SaveEvent(model: any) {
    const url = `${this.apiUrl}events/CreateEvent`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async UpdateEvent(model: any) {
    const url = `${this.apiUrl}events/UpdateEvent`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getApprovedItemsCaseStudy() {
    const url = `${this.apiUrl}SmartBank/getcasestudyapproveditems`;
    return this.getItems<any>(url);
  }

  async jsonToExcel(model: any) {
    const url = `${this.apiUrl}SmartBank/jsontoexcel`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async jsonToExcelforTasks(model: any) {
    const url = `${this.baseService.apiUrl}tasklist/jsontoexcelfortasks`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async loadProjectsByProjectIds(projectIds: string[]): Promise<any> {
    const url = `${this.apiUrl}SmartBank/getprojectNames`;
    return this.postAnyFormData(projectIds, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  //idea-corner
  async sendIdeaCornerQuestionEmail(questionWithAnswers: any) {
    const url = `${this.apiUrl}IdeaCorner/sendideacorneremail`;
    return this.postAnyFormData(questionWithAnswers, url).then(
      (response: any) => {
        return response;
      }
    );

  }
  async getAllTermSet(): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/getallTermSets`;
    return this.getItems<any>(url);
  }
  async getAllHubs(): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/getallHubs`;
    return this.getItems<any>(url);
  }
  async saveTerm(form: any) {
    const url = `${this.apiUrl}SalesAndDeliveryHub/saveTerm`;
    return this.postAnyFormData(form, url).then(
      (response: any) => {
        return response;
      }
    );

  }
  async getMappedTermHub(): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/getTermHubMapping`;
    return this.getItems<any>(url);
  }
  async saveFileTaxonomy(form: any) {
    const url = `${this.apiUrl}SalesAndDeliveryHub/saveTaxonomyFiles`;
    return this.postAnyFormData(form, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async saveShareableTaxonomyfile(form: any) {
    const url = `${this.apiUrl}SalesAndDeliveryHub/saveShareableTaxonomyFiles`;
    return this.postAnyFormData(form, url).then(
      (response: any) => {
        return response;
      }
    );
  }

  downloadFiles(): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/DownLoadInZip`;
    return this.getItems<any>(url);

  }
  getTaxonomyFiles(id: String, packageType: SharepointPackageType): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/gettaxonomyfiles/${id}/${packageType}`;
    return this.getItems<any>(url);
  }
  /**
   * Downloads the selected taxonomy files as a zip. The API streams the archive
   * rather than buffering it, so the response is the raw bytes — a blob, not the
   * base64 payload this used to return.
   */
  downloadTaxonomyFile(formData: any): Promise<Blob> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/downloadfile`;
    return this.postAnyFormDataBlob(formData, url);
  }
  removesavedfile(fileName: string) {
    const url = `${this.apiUrl}SalesAndDeliveryHub/removesavedfile/${fileName}`;
    return this.postAny(undefined, url).then(
      (response) => {
        return response;
      }
    );
  }
  getShareableIplist(): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/getshareableiplist`;
    return this.getItems<any>(url);
  }
  downloadShareableIpFile(id: string): Promise<any> {
    const url = `${this.apiUrl}SalesAndDeliveryHub/downloadshareableipfile/${id}`;
    return this.getItems<any>(url);
  }
  downloadCaseStudyFile(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/downloadfile/${id}`;
    return this.getItems<any>(url);
  }

  async saveMappedUserRoles(model: any) {
    const url = `${this.apiUrl}AdminDashboard/savemappeduserroles`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async saveMappedFeaturesRoles(model: any) {
    const url = `${this.apiUrl}AdminDashboard/savemappedfeatureroles`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async saveMappedRoleFeatures(model: any) {
    const url = `${this.apiUrl}AdminDashboard/savemappedrolefeatures`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }

  async saveMappedRoleUsers(model: any) {
    const url = `${this.apiUrl}AdminDashboard/savemappeduserroles`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getMappedUsers(roleid: string): Promise<any> {
    const url = `${this.apiUrl}AdminDashboard/getmappedusers/${roleid}`;
    return this.getItems<any>(url);
  }
  async getMappedUserRoles(id: string): Promise<any> {
    const url = `${this.apiUrl}AdminDashboard/getmappeduserroles/${id}`;
    return this.getItems<any>(url);
  }

  async getMappedRoleFeatures(roleid: string): Promise<any> {
    const url = `${this.apiUrl}AdminDashboard/getmappedrolefeatures/${roleid}`;
    return this.getItems<any>(url);
  }

  async getMappedFeatureRoles(featureid: string): Promise<any> {
    const url = `${this.apiUrl}AdminDashboard/getmappedfeatureroles/${featureid}`;
    return this.getItems<any>(url);
  }

  async getMappedRoleUsers(id: string): Promise<any> {
    const url = `${this.apiUrl}AdminDashboard/getmappeduserroles/${id}`;
    return this.getItems<any>(url);
  }

  async getMappedUserFeatures(): Promise<any> {
    const url = `${this.apiUrl}AdminDashboard/getcurrentuserfeatures`;
    return this.getItems<any>(url);
  }

  async getCurrentRoleUser(): Promise<any> {
    const url = `${this.apiUrl}Users/getcurrentroleuser`;
    return this.getItems<any>(url);
  }
  async getUserRoles(): Promise<any> {
    const url = `${this.apiUrl}AdminDashboard/users`;
    return this.getItems<any>(url);
  }

  async saveMappedRoleModules(model: any) {
    const url = `${this.apiUrl}Modules/savemappedrolemodules`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }

  async getMappedRoleModules(id: string): Promise<any> {
    const url = `${this.apiUrl}Modules/getmappedrolemodules/${id}`;
    return this.getItems<any>(url);
  }
  async saveMappedGroupApplications(model: any) {
    const url = `${this.apiUrl}AdminApplications/savemappedgroupapplications`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async saveMappedApplicationRegions(model: any) {
    const url = `${this.apiUrl}ApplicationRegion/savemappedapplicationregion`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getmappedgroupapplications(id: string): Promise<any> {
    const url = `${this.apiUrl}AdminApplications/getmappedgroupapplications/${id}`;
    return this.getItems<any>(url);
  }
  async getMappedApplicationRegions(id: string): Promise<any> {
    const url = `${this.apiUrl}ApplicationRegion/getmappedapplicationregions/${id}`;
    return this.getItems<any>(url);
  }

  async getIdeaCornerResult(): Promise<any> {
    const url = `${this.apiUrl}IdeaCorner/getIdeaCornerResult`;
    return this.getItems<any>(url);

  }
  async saveAuditLogItems(model: any) {
    const url = `${this.apiUrl}AuditLog/saveAuditLogItems`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }

  async saveSDDownloadlog(model: any) {
    const url = `${this.apiUrl}AuditLog/saveSDDownloadlog`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getMappedclient(): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/GetMarketInsightCompany`;
    return this.getItems<any>(url);
  }
  async getMarketInsightClient(): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/MarketInsightClient`;
    return this.getItems<any>(url);
  }
  async getClientDetails(clientId: string): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/GetMarketInsightClientDetails/${clientId}`;
    return this.getItems<any>(url);
  }
  async getAllContent(email: any): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getcuratecontentList/${email}`;
    return this.getItems<any>(url);
  }
  async getMarketInsightTopics(email: any): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getmarketinsighttopic/${email}`;
    return this.getItems<any>(url);
  }
  async getclientChecklist(): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getClientCheckList`;
    return this.getItems<any>(url);
  }

  async saveChecklistUserMapping(model: any) {
    const url = `${this.apiUrl}tasklist/savechecklistUsersMapping`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }

  async getclientUserMapping(): Promise<any> {
    const url = `${this.apiUrl}tasklist/getClientUserMapping`;
    return this.getItems<any>(url);
  }
  async getClientContact(licenseId: string): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/MarketInsightClientContacts/${licenseId}`;
    return this.getItems<any>(url);
  }
  async getCsrMappedCompanies(email?: string): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/GetCsrMappedCompanies/${email}`;
    return this.getItems<any>(url);
  }
  async getCompanyList(): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getCompanyList`;
    return this.getItems<any>(url);
  }
  async saveUserCompanyMapping(model: any) {
    const url = `${this.apiUrl}MarketInsight/saveMappingUserCompany`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getselectedCompany(id: string): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getmappedusercompany/${id}`;
    return this.getItems<any>(url);
  }
  async saveClientContactMapping(model: any) {
    const url = `${this.apiUrl}MarketInsight/saveclientcontactcuration`;
    return this.postAnyFormData(model, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async saveCheckListAdmin(user: any) {
    const url = `${this.apiUrl}MarketInsight/savechecklistadminusers`;
    return this.postAnyFormData(user, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async selectedCurateContent(email: string): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getselectedcuratecontent/${email}`;
    return this.getItems<any>(url);
  }
  async getMIPUser(): Promise<any> {
    const url = `${this.apiUrl}Users/getMipUser`;
    return this.getItems<any>(url);
  }
  async getClientOverview(): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getclientoverview`;
    return this.getItems<any>(url);
  }
  async saveExternalMarketInsightFileWithMapping(form: any) {
    const url = `${this.apiUrl}MarketInsight/saveExternalMarketInsightFileWithMapping`;
    return this.postAnyFormData(form, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getfile(fileId:any): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/curatedcontent/${fileId}`;
    return this.getItems<any>(url);
  }
  async saveEBRfile(form: any) {
    const url = `${this.apiUrl}MarketInsight/saveEBRFile`;
    return this.postAnyFormData(form, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getEBRFileByClientId(clientid: any): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getEBRfilebyclientid/${clientid}`;
    return this.getItems<any>(url);
  }

  async deleteEBRFile(fileid: any) {
    const url = `${this.apiUrl}MarketInsight/deleteEBRFile/${fileid}`;
    return this.deleteAny(url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async saveWorkshopFile(form: any) {
    const url = `${this.apiUrl}MarketInsight/saveWorkshopFile`;
    return this.postAnyFormData(form, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getWorkshopData(): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getworkshopdetails`;
    return this.getItems<any>(url);
  }

  async deleteWorkshopFile(fileid: any) {
    const url = `${this.apiUrl}MarketInsight/deleteworkshopfile/${fileid}`;
    return this.deleteAny(url).then(
      (response: any) => {
        return response;
      }
    );
  }

  async checkListInactive(inactiveModel: any) {
    const url = `${this.apiUrl}tasklist/inactivechecklist/${inactiveModel}`;
    return this.postAny(inactiveModel, url).then(
      (response: any) => {
        return response;
      }
    );
  }
  async getWorkshopbyclientid(clientid: any): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/workshop/${clientid}`;
    return this.getItems<any>(url);
  }

  async getclientebrdata(): Promise<any> {
    const url = `${this.apiUrl}MarketInsight/getclientebrdata`;
    return this.getItems<any>(url);
  }

  async saveProposalSlide(data: any) {
    const url = `${this.apiUrl}SmartBank/saveProposalSlide`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }

  async saveProposalExample(data: any) {
    const url = `${this.apiUrl}SmartBank/saveProposalExample`;
    return this.postAnyFormData(data, url).then(
      (response) => {
        return response;
      }
    );
  }

  getPropsalSlide(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/getPropsalSlide/${id}`;
    return this.getItems<any>(url);

  }
  getPropsalExample(id: string): Promise<any> {
    const url = `${this.apiUrl}SmartBank/getPropsalExample/${id}`;
    return this.getItems<any>(url);

  }

  //AiOps Chart Data
  async getAIOpsChart(id: string): Promise<any> {
    const url = `${this.apiUrl}Assessment/aiOpsChart/${id}`;
    return this.getItems<any>(url);
  }
}

export interface SmartBankRejectionReason {



  id?: string
  description?: string;
}
export interface IPinnedTile {
  id: string;
  tileId: string;
  userEmail: string;
  tileType: string;

}

export interface ILatestProjectDeliverable {
  id: string
  title: string;
  url: string;
  modifiedDate: Date;
  author: string;
}



export interface FileDetails {
  name: string;
  fileDetails: any;
}
///smart Bank All Object Classes


export interface WorkspaceDDItem {

  id?: string;
  name?: string;

}

export interface UserRole {

  id?: string;
  firstname?: string;
  lastname?: string;
  email?: string;

}

export interface Teams {
  id: string;
  teamName: string;
  webUrl: string;
}
export interface WorkspaceModel {
  workspaceName?: string;
  workspaceDescription?: string;
  oneSysProjects?: WorkspaceDDItem[];
  selectedOneSysProject?: string;
  teams?: Teams[];
  selectedTeam?: string;
  staff?: Staff[];
  selectedUserJson?: string;
  channels?: TeamChannel;
  selectedChannel?: string;
  msTeamsName?: string;
  msChannelName?: string;
}

export interface SearchParameter {
  searchText?: string;
  querySelectAll?: boolean;
  queryReferenceItem?: boolean;
  queryTipOfTheWeek?: boolean;
  queryDidYouKnow?: boolean;
  queryCaseStudy?: boolean;
}
export interface TeamChannel {
  id?: string;
  channelName?: string;
  webUrl?: string;
  builtWebUrl?: string;
}

export interface WorkspaceTaskListModel {
  id?: string;
  workspaceId?: string;
  taskListId?: string;
  name?: string;
  user?: string;
  userProfileId?: string;
  createdDate?: Date;

}
export interface WorkspaceHistory {
  id?: string;
  workspaceId?: string;
  userEmail?: string;
  historyDetails?: string;
  createdDateFormatted?: Date;
  createdDate?: Date;
}
export interface WorkspaceFavouriteDocument {
  id?: string;
  documentId?: string;
  documentName?: string;
  url?: string;
  imageName?: string;
}
export interface WorkspaceNotificationItem {
  id?: string;
  parentId?: string;
  applicationName?: string;
  message?: string;
  actionUrl?: string;
  createdDate?: Date;
  createdDateFormatted?: Date;
}
export interface WorkspaceAssessment {
  workspaceId?: string;
  id?: string;
  assessmentId?: string;
  title?: string;
  createdBy?: string;
  createdDate?: Date;
  createdDateFormatted?: Date;
}
export interface WorkspaceAssessmentModel {
  workspaceId?: string;
  assessmentId?: string[];
}
export interface WorkspaceTeamMember {
  workspaceId?: string;
  staffList?: string[];
}
export interface WorkspaceNotificationDetails {
  message?: string;
  actionUrl?: string;
  title?: string;
}
export interface WorkspaceSummaryDetails {
  projectEndDate?: Date;
  percentageComplete?: number;
  expenseBurn?: string;
  pTDProfitability?: number;
  lastActivityDate?: Date;
  lastActivityDisplay?: string;
}
export interface WorkspaceSelectedTeamModel {
  workspaceId?: string;
  selectedChannel?: string;
  teamId?: string;
  channelId?: string;
  msTeamsName?: string;
  msChannelName?: string
}
export interface FavouriteDocumentModel {
  workspaceId?: string;
  favouriteDocumentList?: WorkspaceFavouriteDocument[];
}
export interface CarbonOffset {
  travelEmissions?: string;
  travelEmissionsDescription?: string;
  treesRequired?: string;
  treesDescription?: string;
}
export interface WordOfTheWeek {
  id?: string;
  word?: string;
  details?: string;
  startDate?: Date;
  createdBy?: string;
  createdDate?: Date;
  startDateModified?: Date;
}
export interface MetricsData {
  id?: string;
  selectProc?: string;
  title?: string;
  value?: string;
  sortOrder?: number;
  actionUrl?: string;
  toolTip?: string;
}
export interface MiroHomeModel {
  clientId?: string;
  teamId?: string;
  authoriseUrl?: string;
  callBackTokenUrl?: string;
}
export interface LatestProjectShareable {
  id: string
  title: string;
  modifiedDate: string;
  author: string;
}
export interface ProposalsTermMapping {
  id: string; // Guid in C# is typically represented as string in TypeScript
  proposalLinkName: string;
  termId: string; // Guid in C# is typically represented as string in TypeScript
}
